import axios from "axios";
import React, { useEffect, useState } from "react";
import { getCurrentDate } from "../../../Utilitie";
import Loading from "../../../Extra/Loading";
const tableHead = ["MEXP", "PASS", "TOD"];
const tableHeading = ["Year", "PP Date", "T Type", "RPT"];
const PunBestEverDataMaster = () => {
  const [bestEverData, setBestEverData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [date, setDate] = useState(getCurrentDate());
  const urlPrefix = process.env.REACT_APP_URL_PREFIX_CRIS;
  const fetchData = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await axios.get(
        `${urlPrefix}get_best_ever_punctuality_performance_RPT_report02?date=${date}`,
      );

      setBestEverData({
        MEXP: response.data.data_totalM,
        PASS: response.data.data_totalP,
        TOD: response.data.data_MPSO_TOD,
      });
      setLoading(false);
    } catch (err) {
      setLoading(false);
      setError(err);
    }
  };
  useEffect(() => {
    fetchData();
  }, [date]);
  return (
    <div className="m-1">
      <div
        className="bg-dar text-white d-flex justify-content-between align-items-center"
        style={{
          background: " rgba(0, 0, 50, 0.6)",
        }}
      >
        <b className="ms-2">Punctuality Best Ever Data</b>
        {/* <input
          className="form-select "
          style={{ width: "150px" }}
          type="date"
          onChange={(e) => {
            setDate(e.target.value);
          }}
          value={date}
          max={getCurrentDate()}
        /> */}
      </div>
      {loading && <Loading />}
      {bestEverData && (
        <div className="">
          <div className="row">
            {tableHead.map((head, h) => {
              const uniqueYear = [
                ...new Set(
                  bestEverData[head].last_fy_data.map((y) => y.financial_year),
                ),
              ];

              uniqueYear.sort((a, b) => b - a);

              return (
                <div key={h} className="col-md-4 mt-1 ">
                  <div
                    className="bg-dar text-white rounded mb-1"
                    style={{
                      fontWeight: "bold",
                      background: "rgba(0, 0, 50, 0.6)",
                    }}
                  >
                    {head}
                  </div>

                  <div className="table-responsive me-1">
                    <table className="table glassTable">
                      <thead>
                        <tr>
                          {tableHeading.map((h, hh) => (
                            <th key={hh}>{h}</th>
                          ))}
                        </tr>
                      </thead>

                      <tbody>
                        {uniqueYear.map((y, hy) => {
                          const record = bestEverData[head].last_fy_data.find(
                            (o) => o.financial_year === y,
                          );

                          return (
                            record && (
                              <tr key={hy}>
                                <td>{y}</td>
                                <td>{record.report_date.slice(0, 10)}</td>
                                <td>{head}</td>
                                <td>{record.RPT}</td>
                              </tr>
                            )
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};
export default PunBestEverDataMaster;
